import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { QUERY_FILTER_MARKET_BOOKSTORE, QueryFilter } from 'src/component/shared';

import { AreaChart, CartesianGrid, XAxis, YAxis, Tooltip, Area, ResponsiveContainer, Legend } from 'recharts';
import { Paper, Typography, LinearProgress, Grid } from '@material-ui/core';
import { NumberConvert, MoneyLessBRL } from '../../../../../services';

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreShareBillingEvolutionByMonthProps {
    filter: string[]
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreShareBillingEvolutionByMonthState {
    customFilter: {
        isChart: boolean
    },
}

export interface IMarketShareBookstoreShareBillingEvolutionByMonthDataChart {
    currentYear: number | null;
    currentYearBilling: number | null;
    currentYearBillingLabel: string | null;
    currentYearVolume: number | null;

    lastYear: number | null;
    lastYearBilling: number | null;
    lastYearBillingLabel: string | null;
    lastYearVolume: number | null;

    month: string;

    twoYearsPast: number | null;
    twoYearsPastBilling: number | null;
    twoYearsPastBillingLabel: string | null;
    twoYearsPastVolume: number | null;
}

const BILLING_EVOLUTION_QUERY = gql`
query marketShareBookstoreBillingEvolutionByMonth($customFilter: MarketShareCustomFilter) {
    marketShareBookstoreBillingEvolutionByMonth(marketShareCustomFilter: $customFilter) {
        month,
        currentYear,
        currentYearBilling,
        currentYearVolume,
        lastYear,
        lastYearBilling,
        lastYearVolume,
        twoYearsPast,
        twoYearsPastBilling,
        twoYearsPastVolume
  }
}
`;

const dataFilled = (data: any) => {
    return data && data.marketShareBookstoreBillingEvolutionByMonth && !!data.marketShareBookstoreBillingEvolutionByMonth.length
}

// statless component
const CustonTooltipData = (props: any) => {

    let content;
    props.payload !== null &&  props.payload.length !== undefined && props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (
        <div className="tooltip-box">
            <table>
                <tbody>
                    <tr className="tooltip-text">
                        <td className="tooltip-title" style={{paddingRight: 10}}>Ano</td>
                        <td className="tooltip-title" style={{paddingRight: 10}}>Faturamento:</td>
                        <td className="tooltip-title" style={{paddingRight: 10}}>Volume:</td>
                    </tr>
                    <tr className="tooltip-text">
                        <td className="tooltip-title" style={{paddingRight: 10}}> {content && content.currentYear} </td>
                        <td className="tooltip-content" style={{paddingRight: 10}}>{content && content.currentYearBillingLabel}</td>
                        <td className="tooltip-content" style={{paddingRight: 10}}>{content && content.currentYearVolume}</td>
                    </tr>
                    <tr className="tooltip-text">
                        <td className="tooltip-title" style={{paddingRight: 10}}> {content && content.lastYear} </td>
                        <td className="tooltip-content" style={{paddingRight: 10}}>{content && content.lastYearBillingLabel}</td>
                        <td className="tooltip-content" style={{paddingRight: 10}}>{content && content.lastYearVolume}</td>
                    </tr>
                    <tr className="tooltip-text">
                        <td className="tooltip-title" style={{paddingRight: 10}}> {content && content.twoYearsPast} </td>
                        <td className="tooltip-content" style={{paddingRight: 10}}>{content && content.twoYearsPastBillingLabel}</td>
                        <td className="tooltip-content" style={{paddingRight: 10}}>{content && content.twoYearsPastVolume}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

// statless component
const MarketShareBookstoreShareBillingEvolutionByMonthChart = ({ data, loading } : 
    { data: IMarketShareBookstoreShareBillingEvolutionByMonthDataChart[], loading:boolean }) => (
        <ResponsiveContainer width="100%" height={370}>
            <AreaChart
                data={data}
                margin={{ top: 10, right: 30, left: 30, bottom: 0, }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip content={<CustonTooltipData isAnimationActive={false}  />} />
                <Legend verticalAlign="bottom" height={20}/>
                <Area name="Ano Atual" type="monotone" dataKey="currentYearBilling" stroke="#00aeef" fill="#00aeef" fillOpacity={0.3} />
                <Area name="Ano Passado" type="monotone" dataKey="lastYearBilling" stroke="#323232" fill="#323232" fillOpacity={0.3} />
                <Area name="Dois Anos Atrás" type="monotone" dataKey="twoYearsPastBilling" stroke="#67AB2B" fill="#67AB2B" fillOpacity={0.3} />
            </AreaChart>
        </ResponsiveContainer>
);

export class MarketShareBookstoreShareBillingEvolutionByMonth extends React.Component<IMarketShareBookstoreShareBillingEvolutionByMonthProps, IMarketShareBookstoreShareBillingEvolutionByMonthState> {

    constructor(props: IMarketShareBookstoreShareBillingEvolutionByMonthProps) {
        super(props);
        this.state = {
          customFilter: {
            isChart: true,
          },
        }
    }

    public render() {
        const jsonFilter = {
            "customFilter": {
                "isChart": this.state.customFilter.isChart,
            }
        };

        return (
            <Query query={QUERY_FILTER_MARKET_BOOKSTORE} notifyOnNetworkStatusChange={true} >
            {({ loading: loadingC, error: errorC, data: cache, client: clientC}) => {
                return (
                    <Query query={BILLING_EVOLUTION_QUERY} variables={QueryFilter.getFilterMarketBookstore(clientC, jsonFilter, this.props.filter, false)} >
                    {({ loading, error, data}) => {
                        return (
                            <Grid item={true} xs={12}>
                                <Paper className="publisher-sale-block panel-block" >
                                    <Typography variant="headline" className="panel-title" component="title">
                                        Faturamento por Mês - Ano atual X Anos anteriores
                                    </Typography>

                                    {
                                        loading
                                        ?
                                        <LinearProgress />
                                        :
                                        (
                                            dataFilled(data)
                                            ?
                                            (
                                                <MarketShareBookstoreShareBillingEvolutionByMonthChart 
                                                    data={this.convertData(data.marketShareBookstoreBillingEvolutionByMonth)}
                                                    loading={loading} 
                                                />
                                            )
                                            :
                                            (
                                                <Typography variant="body2" className="comparative" component="p">
                                                    Não há informações de vendas
                                                </Typography>
                                            )
                                        )
                                    }
                                </Paper>
                            </Grid>
                        );
                    }}
                    </Query>
                );
            }}
            </Query>
        );
    }

    private convertData = (data: any[]) => {

        const mappedData: IMarketShareBookstoreShareBillingEvolutionByMonthDataChart[] = [];

        if(data) {
            data.forEach(e => {
                const item: IMarketShareBookstoreShareBillingEvolutionByMonthDataChart = {
                    currentYear: e.currentYear && e.currentYear > 0 ? NumberConvert(e.currentYear.toString()) : null,
                    currentYearBilling: e.currentYearBilling && e.currentYearBilling > 0 ? NumberConvert(e.currentYearBilling.toString()) : null,
                    currentYearBillingLabel: e.currentYearBilling && e.currentYearBilling > 0 ? MoneyLessBRL(e.currentYearBilling.toString()) : null,
                    currentYearVolume: e.currentYearVolume && e.currentYearVolume > 0 ? NumberConvert(e.currentYearVolume.toString()) : null,

                    lastYear: e.lastYear && e.lastYear > 0 ? NumberConvert(e.lastYear.toString()) : null,
                    lastYearBilling: e.lastYearBilling && e.lastYearBilling > 0 ? NumberConvert(e.lastYearBilling.toString()) : null,
                    lastYearBillingLabel: e.lastYearBilling && e.lastYearBilling > 0 ? MoneyLessBRL(e.lastYearBilling.toString()) : null,
                    lastYearVolume: e.lastYearVolume && e.lastYearVolume > 0 ? NumberConvert(e.lastYearVolume.toString()) : null,

                    month: e.month,

                    twoYearsPast: e.twoYearsPast && e.twoYearsPast > 0 ? NumberConvert(e.twoYearsPast.toString()) : null,
                    twoYearsPastBilling: e.twoYearsPastBilling && e.twoYearsPastBilling > 0 ? NumberConvert(e.twoYearsPastBilling.toString()) : null,
                    twoYearsPastBillingLabel: e.twoYearsPastBilling && e.twoYearsPastBilling > 0 ? MoneyLessBRL(e.twoYearsPastBilling.toString()) : null,
                    twoYearsPastVolume: e.twoYearsPastVolume && e.twoYearsPastVolume > 0 ? NumberConvert(e.twoYearsPastVolume.toString()) : null,
                };
                mappedData.push(item);
            });
        }

        return mappedData;
    }
    
}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/marketShare/billing-evolution-by-month/MarketShareBookstoreShareBillingEvolutionByMonth.tsx